import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';
import './MediaSlider.css';


const API_KEY = 'AIzaSyAsIkemre8E376xBAE_bBZlgRlbtqWhIPA';
const CHANNEL_ID = 'UCFcKlA6WzJGPF0M3ika-Bmw';
const CACHE_KEY = 'mediaSliderVideos';
const CACHE_TIME_KEY = 'mediaSliderCachedTime';
const CACHE_DURATION_MS = 1000 * 60 * 60 * 2; // 2 hours

const MediaSlider = () => {
  const [videos, setVideos] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const now = new Date().getTime();
    const cached = localStorage.getItem(CACHE_KEY);
    const cachedTime = localStorage.getItem(CACHE_TIME_KEY);

    if (cached && cachedTime && now - cachedTime < CACHE_DURATION_MS) {
      setVideos(JSON.parse(cached));
      setLoading(false);
      return;
    }

    const fetchVideos = async () => {
      try {
        const res = await axios.get('https://www.googleapis.com/youtube/v3/search', {
          params: {
            key: API_KEY,
            channelId: CHANNEL_ID,
            part: 'snippet,id',
            order: 'date',
            maxResults: 6,
          },
        });

        const twoWeeksAgo = new Date();
        twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);

        const videoItems = res.data.items
          .filter(item => item.id.kind === "youtube#video")
          .filter(item => new Date(item.snippet.publishedAt) >= twoWeeksAgo);

        setVideos(videoItems);
        localStorage.setItem(CACHE_KEY, JSON.stringify(videoItems));
        localStorage.setItem(CACHE_TIME_KEY, now.toString());
      } catch (err) {
        console.error('Failed to fetch YouTube videos:', err);
        setError('Unable to load videos at this time. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <div className="media-slider-section">
      <h2 className="text-center mb-4 heading">Latest Videos</h2>

      {loading ? (
        <div className="text-center">Loading videos...</div>
      ) : error ? (
        <div className="text-center text-red-600">{error}</div>
      ) : (
        <>
          <Slider {...settings}>
            {videos.map(video => (
              <div key={video.id.videoId} className="video-slide">
                <ReactPlayer
                  url={`https://www.youtube.com/watch?v=${video.id.videoId}`}
                  width="100%"
                  height="200px"
                  controls
                />
                <p className="video-title">{video.snippet.title}</p>
              </div>
            ))}
          </Slider>

          <div className="text-center mt-4">
            <Link to="/gallery" className="load-more-button">Load More</Link>
          </div>
        </>
      )}
    </div>
  );
};

export default MediaSlider;
